import api from './index.js';


export async function getApplicantsList() {
    try {
        const response = await api.get('/applicants');
        return response;
    } catch (error) {
        console.error(error);
    }
}

export const approveApplicant = (id, remarks) => {
    return api.put(`/applicants/${id}/status`, { 
        status: 'approve',
        remarks 
    });
};

export const rejectApplicant = (id, remarks) => {
    return api.put(`/applicants/${id}/status`, { 
        status: 'reject',
        remarks 
    });
};

export async function resendVerification(id){
    try {
        const response = await api.get(`/applicants/verify-resend/${id}`);
        return response;
    } catch (error) {
        console.error(error);
    }
}
